/*订单列表相关接口*/
import {postAjaxRequest} from '@/utils/request'
import {yqfApiurl, yqfComApiurl, apiurl} from '@/utils/webconfig'

// 获取销售订单列表
export function getSalesOrderList(parm, callback) {
	console.log('getSalesOrderList');
	postAjaxRequest(apiurl + '/OrderAPIV2/GetSalesOrderList', parm, function(result) {
		callback(result);
	})
}

// 生成订单列表请求参数
export function generateOrderListParams(options = {}) {
	const defaultParams = {
		BookerID: "",
		PageCount: 1,
		PageSize: 10,
		StartDate: "",
		EndDate: "",
		yqfkey: "",
		time: new Date().getTime(),
		clientplatform: "H5",
		mpid: "11",
		useraccountno: "",
		userCompanyCode: "",
		userCompanyName: "",
		userRoleID: 0,
		userOrganizaType: "INCU",
		userBizAccount: ""
	}

	return { ...defaultParams, ...options }
}